import { StoreAction, ApiError } from '../../models/rootState.model';
// tslint:disable: class-name

// Types
export const API_ACTION_TYPES = {
    API_OFFLINE: '[Api] -Server is offline-',
    API_ONLINE: '[Api] - Server is online-'
};

// Classes

export class Action_Api_Online implements StoreAction<any> {
    readonly type = API_ACTION_TYPES.API_ONLINE;
}

export class Action_Api_Offline implements StoreAction<ApiError> {
    readonly type = API_ACTION_TYPES.API_OFFLINE;
    constructor(public payload: ApiError) { }
}

// Type
export type ApiAction =
    | Action_Api_Online
    | Action_Api_Offline;
